<template>
  <v-layout>
    <v-flex >
      <panel :title="$t('buildingDetails.editBuilding')">
        <v-text-field
          :label="$t('buildingGenerics.buildingId')"
          disabled
          :rules="[required]"
          v-model="building.building_id"
        ></v-text-field>

        <v-text-field
          :label="$t('buildingGenerics.buildingName')"
          required
          :rules="[required]"
          v-model="building.building_name"
        ></v-text-field>

        <v-text-field
          :label="$t('buildingGenerics.buildingDescr')"
          required
          :rules="[required]"
          v-model="building.description"
        ></v-text-field>
        <v-select
            v-model="building.site_id"
            :items="sites"
            required
            :rules="[required]"
            item-text="site_name"
            item-value="site_id"
            :label="$tc("site", 1)"
        ></v-select>
        <div class="danger-alert" v-if="error">
          {{error}}
        </div>
        <v-layout class="modal-button-row">
          <v-btn
            dark
            block
            class="button-delete button-modal"
            @click="this.delete">
            {{$t('actions.delete')}}
          </v-btn>
          <v-btn
            dark
            block
            class="secondary button-modal"
            @click="save">
            {{$t('actions.saveModifications')}}
          </v-btn>
        </v-layout>
      </panel>
    </v-flex>
  </v-layout>
</template>

<script>
import BuildingsApi from '@/api/buildings-api'
import SitesService from '@/services/SitesService'

export default {
  props: [
    'selectedId'
  ],
  data () {
    return {
      building: {
        building_id: null,
        building_name: null,
        description: null,
        site_id: null
      },
      error: null,
      required: (value) => !!value || 'Required.',
      sites: []
    }
  },
  methods: {
    async save () {
      this.error = null
      try {
        await BuildingsApi.put(this.building.building_id, this.building)
        this.$emit('close') // notify parent to close the modal
      } catch (err) {
        this.error = err.response.statusText
        console.log(err)
      }
    },
    async delete () {
      this.error = null
      try {
        await BuildingsApi.delete(this.building.building_id)
        this.$emit('close') // notify parent to close the modal
      } catch (err) {
        console.log(err)
        this.error = err
      }
    }
  },
  async mounted () {
    try {
      this.error = null
      this.sites = (await SitesService.index()).data
    } catch (err) {
      console.log(err)
      this.error = err
    }
  },
  watch: {
    selectedId: async function (val) {
      try {
        this.error = null
        const buildingID = this.selectedId
        this.building = (await BuildingsApi.get(buildingID)).data
      } catch (err) {
        console.log(err)
        this.error = err
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/EditBuilding.vue